import styled from "styled-components";

export const StyledTemplateSidebar = styled.div`
    width: 100%;
    max-width: 313px;
    /* max-height: 95dvh; */
    border-radius: 20px;
    border: 1px solid rgba(233, 233, 233, 1);
    background-color: var(--white);
    overflow-y: auto;
    margin-right: 5px;
    position: fixed;
    top: 100px;
    bottom: 17px;
    left: 40px;
    .tabs-wrap {
        list-style: none;
        padding: 20px 15px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
        border-bottom: 1px solid rgba(233, 233, 233, 1);
        li {
            button {
                width: 100%;
                min-width: auto;
                &.active {
                    img {
                        filter: invert(100%) sepia(0%) saturate(7497%) hue-rotate(270deg) brightness(120%)
                            contrast(111%);
                    }
                }
            }
        }
    }
`;
